import ReactDOM from 'react-dom';
import './extend-entities';
import App from '../components/app';

export default () => {
    ReactDOM.render(<App />, document.getElementById('root'));
}
